<!-- eslint-disable -->
<script setup>
import weatherComponent from "@/components/weather/index.vue";
</script>
<!-- eslint-disable -->
<template>
  <div class="row mb-3">

    <div class="col-xl-5 col-lg-5 mb-3 d-flex align-items-stretch card-100">
      <div class="card card-stats mb-4 mb-xl-0">
        <div class="card-body position-relative min-h-100">
          <SectionLoaderView v-if="isRequestBestDay" />
          <div class="row height-100">
            <div class="col height-100">
              <div
                class="statistique statistique-font-size font-weight-bold mb-0 d-flex height-100 justify-content-center align-items-center">
                <div class="text-center">

                  <div class="mt-2">
                    <span>
                      {{
                      dashboard.meilleur_jour
                      ? dashboard?.meilleur_jour?.TotalValue?.toFixed(2)
                      : "0.00"
                      }}
                      €
                    </span>
                  </div>
                  <div>
                    <p class="mt-1 mb-0 text-muteds text-sm">
                      <span class="text-nowrap font-size-20">
                        {{
                        dashboard.meilleur_jour
                        ? $moment(dashboard?.meilleur_jour?.jour).format(
                        "DD/MM/YYYY"
                        )
                        : "DD/MM/YYYY"
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="hr-border">
                    <span style="font-size: 15px"> {{ $t("content.pages.dashboard.cards.best_day.title") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-7 col-lg-7 mb-3 d-flex align-items-stretch card-100">
      <div class="card position-relative">
        <SectionLoaderView v-if="loadingRequest?.BoardMeilleursVents" />
        <div class="card-header">
          <h3 class="card-title text-left">
            Meilleures 10 ventes
            <div v-if="dashboard.meilleurventes.data && dashboard.meilleurventes.data.length > 0
            " class="float-end">
              <meilleursVentesPDF :exportTo="exportTo.meilleurventes" :vendeur="searchs.vendeurs"
                :dateFrom="datePicker.date.from" :dateTo="datePicker.date.to" />
            </div>
          </h3>
        </div>
        <div v-if="dashboard.meilleurventes.data && dashboard.meilleurventes.data.length > 0" class="card-body">
          <div class="table-responsive  ">

            <DataTable showGridlines stripedRows :value="dashboard.meilleurventes.data">
              <!-- <Column field="LibVendeur" header="Vendeur" sortable></Column> -->
              <Column field="Libelle" header="Article" sortable> </Column>
              <Column field="QteTotal" header="Quantité" sortable> </Column>
              <Column field="TotalTTC" header="Montant (€)" sortable>
                <template #body="slotProps">
                  {{ slotProps.data.TotalTTC.toFixed(2) }} €
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
        <div v-else class="card-body d-flex align-items-center justify-content-center">
          <datanotfound :text="$t(`content.message.datanotfound`)" />
        </div>
      </div>
    </div>
  </div>


</template>
<!-- eslint-disable -->
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import LineChart from "@/components/chartVue/ChartLine.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { isMoreThan24HoursFake } from '@/Utils/useDateDiff'


export default {
  components: { LineChart, VueDatePicker },
  name: "mongoDATA",
  watch: {
    "datePicker.date.range"(newDate, oldDate) {
      if (newDate !== oldDate && newDate?.length > 0)
        this.callFunctions(
          this.datePicker.date.from,
          this.datePicker.date.to,
          this.datePicker.defaultDates.type
        );
    },
  },
  data() {
    return {
      apiKey: "d5d29bfed8ee0aa4b167f3bbd42204ce",
      dashboard: {
        meilleur_jour: [],
        meilleurventes: [],
      },
      exportTo: { 
        meilleurventes: {
          columns: [],
          data: [],
          fileName: "",
        }, 
      },
      pagination: {
        page: 0,
        limit: 4,
        skip: 0,
        per_page: 10,
        data: [],
      },
      searchs: {
        vendeurs: ["vendeur"],
      },

    };
  },
  mounted() {
    this.callFunctions(
      this.datePicker.date.from,
      this.datePicker.date.to,
      this.datePicker.defaultDates.type
    );
    if (this.isAuthenticated && this.isRole == 'manager') {
      this.getMeilleurJourDuMois('month', 'month');
    }
  },
  created() { },
  unmounted() {
  },
  methods: {
    ...mapMutations(["setTicketID"]),
    ...mapActions([
     
      "BoardMeilleurJourDuMois",
      "BoardMeilleursVents",

    ]), 

  
   async callFunctions() {
      if (this.currentSite?._id) {
        const ok = await isMoreThan24HoursFake(this.datePicker.date.range)
        if (ok) {
          // ✅ Safe to continue search
          let range = this.datePicker.defaultDates.type ? this.datePicker.defaultDates.type : this.datePicker.date.from
          this.getBoardMeilleursVents(range, this.datePicker.date.to); 
        }   
       
      }
    },
 
    async getMeilleurJourDuMois(from, to) {
      if (this.currentSite?._id) {
        let qte = "qte";
        let page = 1;
        let limit = 0; // select first element
        let self = this;
        this.dashboard.meilleur_jour = await this.BoardMeilleurJourDuMois({
          url: "board/meilleur-jour-du-mois",
          page: page,
          limit: limit,
          range: self?.datePicker?.defaultDates?.list[4] || null,
          vendeur: "vendeur",
          site: self.currentSite?._id,
          qte: qte,
          WhereLibInArray: [
            { LibValeur: 'vendeur', LibKey: 'LibVendeur' },
            { LibValeur: 'caisse', LibKey: 'LibCaisse' },
            { LibValeur: null, LibKey: 'Operation' },
          ]
        });
      }
    },  

    async getBoardMeilleursVents(from, to) {
      let qte = "qte";
      let page = 1;
      let limit = 10;
      this.dashboard.meilleurventes = await this.BoardMeilleursVents({
        url: "board/meilleursvents",
        page: page,
        limit: limit,
        range: this.datePicker.date.range,
        vendeur: "vendeur",
        site: this.currentSite?._id,
        qte: qte,
        WhereLibInArray: [
          { LibValeur: this.globalSearch?.SelectedLibVendeurs?.length ? this.globalSearch?.SelectedLibVendeurs : 'vendeur', LibKey: 'LibVendeur' },
          { LibValeur: this.globalSearch?.SelectedLibCaisses?.length ? this.globalSearch?.SelectedLibCaisses : 'caisse', LibKey: 'LibCaisse' },
          { LibValeur: ['VENTE', 'ANNULATION'], LibKey: 'Operation' },
        ]
      });
      this.exportTo.meilleurventes.data = [];
      this.exportTo.meilleurventes.data = this.dashboard.meilleurventes.data;
      let file_vendeur = "";
      if (
        this.searchs.vendeurs.length == 1 &&
        this.searchs.vendeurs[0] != "vendeur"
      ) {
        file_vendeur = "-" + this.searchs.vendeurs[0];
      }
      this.exportTo.meilleurventes.fileName =
        "ventes-par-vendeur" + file_vendeur + "_" + from + "_" + to;
      if (this.dashboard.meilleurventes.data.length > 0) {
        this.exportTo.meilleurventes.columns = [];
        if (file_vendeur == "") {
          this.exportTo.meilleurventes.columns.push("Vendeur");
        }
        this.exportTo.meilleurventes.columns.push("Article");
        this.exportTo.meilleurventes.columns.push("Quantité");
        this.exportTo.meilleurventes.columns.push("Montant");
      }
    },




  },
  computed: {
    ...mapGetters({

      isRequestBestDay: "isRequestBestDay",
      isRequestStatPrincipal: "isRequestStatPrincipal",
      isAuthenticated: "isAuthenticated",
      isRole: "isRole",
      res: "StateRes",
      currentSite: "currentSite",
      listChiffreAffaires: "listChiffreAffaires",
      TimeDebutCalclule: "TimeDebutCalclule"
    }),
    ...mapState(["ticket_id", "datePicker", "globalSearch", "loadingRequest"]), 


  },
};
</script>
<!-- eslint-disable -->

<style>
.selected-default-dates {
  background: #084593 !important;
  color: #fff !important;
}

.card-100 .card {
  width: 100%;
}

.card .card-title {
  margin-bottom: 0px !important;
}



.type_ca span.brut {
  border-left: 1px solid #d9d9d9;
  border-right: 0px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.type_ca span.net {
  border-left: 0px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  border-radius: 0 2px 2px 0;
}

.btn-event-export {
  border: 1px solid #bdbdbd;
  padding: 5px;
  text-align: center;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.statistique-font-size {
  font-size: 20px;
}

.statistique {
  font-weight: 600;
  margin-top: 10px !important;
  display: block;
  margin: 0px !important;
}

.height-100 {
  height: 100%;
}

.geolocation.latlong {
  font-size: 15px;
}

.font-size-20 {
  font-size: 14px;
}

.card-body {
  padding: 0.8rem 0.8rem !important;
}


.percentage svg {
  margin-right: 4px;
}

.percentage .red {
  color: red !important;
}

.percentage .green,
.percentage {
  color: #14e114;
}

.percentage {
  width: 90px;
  display: inline-block;
}
</style>
